import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AdvanceReturnValueGreaterThanAdvanceSummaryValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.advance-return-value.greater-than-advance-summary-value');
    }
}
